import { cn } from '@/lib/utils'

export const LoadingSpinner = ({ className }: { className?: string }) => {
	return (
		<div
			className={cn(`h-8 w-8 animate-spin rounded-full border-b-2 border-primary/30 border-b-primary`, className)}
		/>
	)
}
